import { type HTMLAttributes } from 'react'

import { cn } from '@/utils/cn'

export function Card({ className, ...sectionAttributes }: HTMLAttributes<HTMLElement>) {
  return (
    <section
      className={cn('rounded-card border border-ice/22 bg-panel p-3', className)}
      {...sectionAttributes}
    />
  )
}
